import { Button, MenuRoot } from '@/components';
import { useAuth, useConfirm, useUnsavedChanges } from '@/hooks';
import { trans } from '@/i18n';
import { ROUTE_PATH } from '@/routes/paths';
import { msgMaxLength, msgMinLength, msgRequired } from '@/utils';
import { Flex, Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { FaBell, FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import '../../assets/css/admin.scss';

export const schema = yup.object({
  oldPassword: yup
    .string()
    .min(6, msgMinLength(6, trans('account.oldPassword')))
    .max(20, msgMaxLength(20, trans('account.oldPassword')))
    .default(undefined)
    .required(msgRequired('account.oldPassword')),
  newPassword: yup
    .string()
    .min(6, msgMinLength(6, trans('account.newPassword')))
    .max(20, msgMaxLength(20, trans('account.newPassword')))
    .default(undefined)
    .required(msgRequired('account.newPassword')),
  rePassword: yup
    .string()
    .min(6, msgMinLength(6, trans('account.rePassword')))
    .max(20, msgMaxLength(20, trans('account.rePassword')))
    .oneOf([yup.ref('newPassword')], trans('account.rePasswordInvalid'))
    .default(undefined)
    .required(msgRequired('account.rePassword')),
});

function LayoutUser() {
  const { logout } = useAuth();
  const { hasUnsavedChanges, resetChanges } = useUnsavedChanges();
  const { toggleConfirm } = useConfirm();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    if (hasUnsavedChanges) {
      toggleConfirm({
        title: trans('plan.unsavedChangesTitle'),
        message: trans('plan.unsavedChangesMessage'),
        okText: trans('plan.leave'),
        cancelText: trans('plan.stay'),
        onOk: () => {
          resetChanges();
          navigate(ROUTE_PATH.LOGIN);
          logout();
        },
      });
    } else {
      navigate(ROUTE_PATH.LOGIN);
      logout();
    }
  }, [hasUnsavedChanges, resetChanges, toggleConfirm, navigate, logout]);

  // const handleShowModal = useCallback(() => {
  //   setOpenModal(true);
  // }, []);

  return (
    <>
      <MenuRoot positioning={{ placement: 'bottom-start' }}>
        <Flex cursor="pointer" alignItems="center" justifyContent="flex-end" gap={3}>
          {/* logout */}
          <Button className="no-outline" variant="ghost" onClick={handleLogout}>
            <FaUser />
            <Text>{trans('layout.logout')}</Text>
          </Button>
          <Button
            className="no-outline"
            variant="ghost"
            onClick={() => {
              // TODO: xử lý mở thông báo
              console.log('Notification clicked');
            }}
            paddingLeft={0}
          >
            <FaBell />
          </Button>
        </Flex>
      </MenuRoot>
    </>
  );
}

export { LayoutUser };
